import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { IKImage } from "imagekitio-react";
import CourseRating from "./CourseRating";
import { useNavigate } from "react-router-dom";
export default function LessonOverview({
  playerDetails,
  mSkillProgress,
  skillData,
}) {
  const navigate = useNavigate();
  return (
    <>
      <div className="flex w-full flex-col items-start justify-between p-3">
        <div className="flex w-full flex-row items-center justify-between border-b-2 pb-1 md:pb-4">
          <div className="flex w-full flex-col items-start justify-center">
            <h2 className="text-xl font-bold md:text-2xl">About The Lesson</h2>
            <h3 className="pt-4 text-base md:text-lg">
              {playerDetails?.["lesson-name"]}
            </h3>
            <small>{playerDetails["lesson-description"]}</small>
          </div>
          <div className=" justify-centet flex h-16 w-16 items-center md:hidden">
            <CircularProgressbar
              value={mSkillProgress}
              text={`${mSkillProgress}%`}
              strokeWidth={9}
              styles={buildStyles({
                textSize: "30px",
                pathTransitionDuration: 0.5,
                // Colors
                pathColor: `#68DF5B`,
                textColor: "#000",
                trailColor: "#fff",
              })}
            />
          </div>
        </div>
        <div className="flex w-full flex-col pt-3">
          <h2 className="text-xl font-bold md:text-2xl">About The Course</h2>
          <div className="mt-4 flex w-full flex-col items-start justify-between rounded-lg border-2 border-slate-200 p-3 px-4 pt-4 md:flex-row">
            <p className="pb-4 font-semibold md:p-0">Description</p>
            <p className="m-0 w-full text-xs md:mr-8 md:w-2/3 md:text-base">
              {skillData?.["skill-description"]}
            </p>
          </div>
          <div className="mt-4 flex w-full flex-col items-center justify-between rounded-lg border-2 border-slate-200 p-3 px-4">
            <div className="flex w-full items-start justify-between pt-4">
              <p>Overall Rating</p>
              <p className="m-0 md:mr-8 md:w-2/3">
                <FontAwesomeIcon
                  icon={faStar}
                  size="lg"
                  className="text-yellow-500"
                />
                <FontAwesomeIcon
                  icon={faStar}
                  size="lg"
                  className="text-yellow-500"
                />
                <FontAwesomeIcon
                  icon={faStar}
                  size="lg"
                  className="text-yellow-500"
                />
                <FontAwesomeIcon
                  icon={faStar}
                  size="lg"
                  className="text-yellow-500"
                />
                <FontAwesomeIcon
                  icon={faStar}
                  size="lg"
                  className="text-yellow-500"
                />
              </p>
            </div>
            <div className="flex w-full items-start justify-between pt-4">
              <p>Enrolled Users</p>
              <p className="m-0 md:mr-8 md:w-2/3">
                {skillData?.enrolled_user_prefix?.toString() +
                  skillData?.registered_students}
              </p>
            </div>
            <div className="flex w-full items-start justify-between pt-4">
              <p>Last Updated</p>
              <div className="m-0 flex items-center justify-start text-xs md:mr-8 md:w-2/3 md:text-base">
                <FontAwesomeIcon icon={faCalendar} />
                <p className="ml-3 md:mx-3">
                  {new Date(skillData?.created_at).toLocaleString().slice(0, 8)}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full">
          <CourseRating />
        </div>
      </div>

      <div className="flex h-52  w-11/12 flex-col items-center justify-center rounded-lg  bg-overview_green md:ml-10 md:h-48 md:w-5/12 ">
        <div className="md: mt-2">
          <img
            urlEndpoint="https://img.learntube.ai/public-assets/"
            src={
              "https://img.learntube.ai/public-assets/Content_player/newimage.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658385772244"
            }
            transformation={[
              {
                height: "160",
                width: "160",
              },
            ]}
          />
        </div>
        <h1 className="mt-3 mb-2 text-xl text-white md:mt-1 md:mb-0">
          Gift free course to a friend.
        </h1>
        <button
          class="mb-2 h-10 w-36 rounded-md bg-white font-bold text-green-700 shadow-xl hover:bg-gray-300"
          onClick={(event) => navigate("/my-profile/user/referrals")}
        >
          Invite friends
        </button>
      </div>
    </>
  );
}
